<template>
  <el-dialog
    title="编辑通用名"
    :visible.sync="dialog"
    width="500px"
    style="text-align: left"
    :close-on-click-modal="false"
    :before-close="close"
  >
    <div class="addbox">
      <div>
        <el-input
          v-model="generic_name"
          placeholder="通用名，10个字以内，不能重复"
          maxlength="10"
          style="margin: 5px 0 20px"
          disabled
        ></el-input>
      </div>

      <div>
        <el-input-number
          v-model="xly_standard"
          class="input-number-cus"
          :controls="false"
          :min="1"
          :max="999999"
          placeholder="企标当量（按100g企标颗粒换算的饮片量）"
          style="margin: 5px 0 20px;width:100%;"
        ></el-input-number>
      </div>

      <div>
        <el-input-number
          v-model="national_standard"
          class="input-number-cus"
          :controls="false"
          :min="1"
          :max="999999"
          placeholder="国标当量（按100g企标颗粒换算的饮片量）"
          style="margin: 5px 0 20px;width:100%;"
        ></el-input-number>
      </div>

      <div>
        <el-input-number
          v-model="conversion_rate_standard"
          class="input-number-cus"
          :controls="false"
          :precision="2"
          placeholder="转化率"
          @blur="
            () => {
              this.lock = 2;
            }
          "
          style="margin: 5px 0 20px;width:100%;"
        ></el-input-number>
      </div>

      <div>
        <el-input-number
          v-model="conversion"
          class="input-number-cus"
          :controls="false"
          :precision="4"
          placeholder="颗粒饮片当量"
          style="margin: 5px 0 20px;width:100%;"
        ></el-input-number>
      </div>

      <div>
        <el-input
          v-model="full_pname"
          placeholder="全拼"
          style="margin: 5px 0 20px"
        ></el-input>
      </div>
      <div>
        <el-input
          v-model="simple_pname"
          placeholder="简拼"
          style="margin: 5px 0 20px"
        ></el-input>
      </div>
      <div class="flex align-center">
        <el-switch
          v-model="special_drug"
          inactive-text="是否特殊药品"
        ></el-switch>
        <span style="margin: 0 10px 0 30px">特殊药品提醒用量值</span>
        <el-input-number
          v-model="special_drug_level"
          label
          size="small"
        ></el-input-number>
      </div>
    </div>
    <div style="text-align: center; padding-bottom: 10px">
      <el-button @click="closeShow" style="width: 92px">取 消</el-button>
      <el-button type="primary" @click="submit" style="width: 92px"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      generic_name: "",
      simple_pname: "",
      full_pname: "",
      dialog: true,
      special_drug: false,
      special_drug_level: undefined,
      xly_standard: undefined,
      national_standard: undefined,
      conversion: undefined,
      conversion_rate_standard: undefined,
      lock: 1,
    };
  },
  props: ["nameData"],
  watch: {
    xly_standard: {
      handler: function(n) {
        if (n && this.national_standard && this.lock == 2) {
          this.conversion_rate_standard = (this.national_standard / n).toFixed(
            2
          );
        }
      },
      deep: true,
      immediate: true,
    },
    national_standard: {
      handler: function(n) {
        if (n && this.xly_standard && this.lock == 2) {
          this.conversion_rate_standard = (n / this.xly_standard).toFixed(2);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    closeShow() {
      this.$emit("closeShow");
    },
    //提交
    submit() {
      if (!this.simple_pname || !this.full_pname) {
        this.$message.error("请填写完整再提交");
        return false;
      }
      let data = {
        drug_id: this.nameData.drug_id,
        generic_name: this.generic_name,
        simple_pname: this.simple_pname,
        full_pname: this.full_pname,
        special_drug: this.special_drug ? 1 : 0,
        special_drug_level: this.special_drug_level
          ? this.special_drug_level
          : "",
        xly_standard: this.xly_standard,
        national_standard: this.national_standard,
        conversion_rate_standard: this.conversion_rate_standard,
        conversion: this.conversion,
      };
      this.axios.post("platform/template/saveDrugTcmInfo", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("修改成功");
          this.closeShow();
        }
      });
    },
    close() {
      this.closeShow();
    },
  },
  created() {
    let nameData = this.nameData;
    console.log(this.nameData);
    this.alias = nameData.alias;
    this.generic_name = nameData.generic_name;
    this.simple_pname = nameData.simple_pname;
    this.full_pname = nameData.full_pname;
    this.special_drug = nameData.special_drug ? true : false;
    this.special_drug_level = nameData.special_drug_level
      ? nameData.special_drug_level
      : "";
    this.xly_standard = Number(nameData.xly_standard);
    this.national_standard = Number(nameData.national_standard);
    this.conversion_rate_standard = Number(nameData.conversion_rate_standard);
    this.conversion = nameData.conversion;
    this.$nextTick(() => {
      this.lock = 2;
    });
  },
};
</script>
<style lang="scss" scoped>
.addbox {
  padding: 20px;
  box-sizing: border-box;
}
.drugsbox {
  display: flex;
  flex-wrap: wrap;

  .drugname {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: solid 1px #c0c4cc;
    width: 130px;
    padding: 0 10px;
    box-sizing: border-box;
    height: 40px;
    border-radius: 4px;
  }
}
.drugs_item {
  height: 40px;
  display: flex;
  align-items: center;
  margin: 0 20px 10px 0;
}
.unit {
  position: absolute;
  top: 10px;
  left: 47px;
}
</style>
